/**
 * Medical certificates (справки) on file for a female donor
 * (`/v1/donor-card/{donor_id}/documents`). Each organization sees and adds
 * only its own; any other donor answers with 400 / {@link EDonorDocumentErrorCode.NOT_FEMALE}.
 * Editing and deleting are not supported yet.
 */

export const DONOR_DOCUMENT_TYPES = [
  'GYNECOLOGIST',
  'SES_HEPATITIS_A',
  'SES_HEPATITIS_B_C',
  'LPU_PAST_DISEASES',
  'FLUOROGRAPHY_ECG',
  'OTHER',
] as const

export type TDonorDocumentType = (typeof DONOR_DOCUMENT_TYPES)[number]

export type TDonorDocumentStatus = 'ACTIVE' | 'EXPIRED'

/** Fields without a value are left out of the response entirely. */
export interface IDonorDocument {
  id: string
  /** Issue date, `yyyy-MM-dd`. */
  date: string
  type?: TDonorDocumentType
  type_label?: string
  note?: string
  doctor?: string
  /** Issue date + 1 year. */
  expiry_date: string
  status: TDonorDocumentStatus
  status_label: string
  file_id?: string
  file_name?: string
  file_url?: string
  created_at: string
}

export interface ICreateDonorDocumentPayload {
  /** `yyyy-MM-dd`, not later than today. */
  date: string
  type?: TDonorDocumentType
  note?: string
  doctor?: string
  file?: File
}

export const DONOR_DOCUMENT_ACCEPTED_EXTENSIONS = [
  '.pdf',
  '.jpg',
  '.jpeg',
  '.png',
] as const

export const DONOR_DOCUMENT_MAX_FILE_SIZE = 10 * 1024 * 1024

export const DONOR_DOCUMENT_DOCTOR_MAX_LENGTH = 255

export const EDonorDocumentErrorCode = {
  INVALID_FILE_TYPE: '200137',
  FILE_TOO_LARGE: '200108',
  NOT_FEMALE: '200138',
  DATE_IN_FUTURE: '200139',
  DOCTOR_TOO_LONG: '200140',
  NOT_FOUND: '300316',
  NO_FILE: '300314',
} as const
